import React, { useState, useEffect } from "react";
import { ModalLinkButton } from '../Controls/Button/ModalLinkButton';
import { PrivacyPolicy } from '../assets/Documents/PrivacyPolicy';
import { TermsAndConditions } from '../assets/Documents/TermsAndConditions';
import { CookiePolicy } from '../assets/Documents/CookiePolicy';
import { Attributions } from '../assets/Documents/Attributions';
import './css/SPAStickyFooter.css';

interface SPAStickyFooterProps {
    onVisibilityChange?: (value: boolean) => void;
}

export const SPAStickyFooter: React.FC<SPAStickyFooterProps> = ({ onVisibilityChange }) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const footer = document.getElementById("main-footer");

        if (!footer) return;

        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                setVisible(!entry.isIntersecting);
                onVisibilityChange?.(!entry.isIntersecting);
            },
            { threshold: 0 }
        );

        observer.observe(footer);

        return () => observer.disconnect();
    }, []);

    return (
        <div className={`spa-sticky-footer ${visible ? "show" : "hide"}`}>
            <ul>
                <li><ModalLinkButton Title="Privacy Policy" modalTitle="Privacy Policy"><PrivacyPolicy /></ModalLinkButton></li>
                <li><ModalLinkButton Title="Terms and Conditions" modalTitle="Terms and Conditions"><TermsAndConditions /></ModalLinkButton></li>
                <li><ModalLinkButton Title="Cookie Policy" modalTitle="Cookie Policy"><CookiePolicy /></ModalLinkButton></li>
                <li><ModalLinkButton Title="Licensing & Attributions" modalTitle="Licensing & Attributions"><Attributions /></ModalLinkButton></li>
            </ul>
        </div>
    );
};
